import React from 'react';
import styled from 'styled-components'
import { Colors } from '../utils/colors'

const FooterStyle = styled.footer`
  background-color: ${ Colors.dark };
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${ Colors.textTertiary };
  font-size: 12px;

  & a {
    color: rgba(255,215,0,0.7);
    text-decoration: underline;

    &:hover {
      color: ${ Colors.yellow };
    }
  }

  .content {
    width: 100%;
    max-width: 860px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 6px;
    line-height: 1.4;
  }

  .terms-line {
    font-size: 11px;
    color: rgba(255,255,255,0.3);
    text-align: center;
  }

  .divider {
    width: 1px;
    height: 12px;
    background: rgba(255,255,255,0.15);
    display: none;
  }

  @media (min-width: 640px) {
    font-size: 13px;
    .content {
      flex-direction: row;
      justify-content: center;
      gap: 14px;
      flex-wrap: wrap;
    }

    .divider {
      display: inline-block;
    }
  }

  @media (min-width: 1024px) {
    font-size: 14px;
  }
`;

const Footer = () => {

  return (
    <FooterStyle role="contentinfo">
      <div className="content">
        <span>Musitech Studio Digital LTDA</span>
        <span className="divider" />
        <span>CNPJ 40.126.747/0001-05</span>
        <span className="divider" />
        <span>Todos os direitos reservados © 2026</span>
      </div>
    </FooterStyle>
  );
}

export default Footer;